import { createFileRoute } from "@tanstack/react-router"

import { SettingsAccountPage } from "@/pages/settings/account"

// Clerk's <UserProfile routing="path"> owns this path *and* its sub-paths (see profile.$.tsx),
// so both routes render the same page and Clerk picks which of its pages to show.
export const Route = createFileRoute("/_authenticated/settings/account/profile/")({
  component: SettingsAccountPage,
})
